import React from "react";
import { graphql } from "react-apollo";
import { flowRight as compose } from "lodash";
import gql from "graphql-tag";
import {connect} from "react-redux";
import Form from "./StopServiceForm";
import {cancelStopService} from "../../../actions/InfrastructureApiActions";
import {Map} from "immutable";
import {validatePresence} from "../../../lib/Validators";
import {createValidationErrors, createErrors} from "../../../lib/ErrorFormatter";

function validateForm(values) {
  let errors = Map();
  errors = validatePresence(errors, values, "reason");
  return errors.toJS();
}


class StopServiceFormContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = { errors: [] }
  }

  handleSubmit(values) {
    let updatedValues = values.set("serviceId", this.props.serviceId);
    
    return this.props.stopService(updatedValues.toJS())
      .then((response) => {
        if (response.data.stopService.errors.length <= 0) {
          this.props.cancelStopService();
        } else {
          let errors = createValidationErrors(response.data.stopService.errors);
          this.setState({errors: errors});
        }
      })
      .catch((err) => {
        this.setState({errors: createErrors(err)});
      });      
  }

  handleCancel() {
    this.props.cancelStopService();
  }

  render() {
    return (
      <Form
        errors={this.state.errors}
        validate={validateForm}
        onSubmit={this.handleSubmit.bind(this)}
        onCancel={this.handleCancel.bind(this)}
        />
    )
  }

}


const STOP_SERVICE = gql`
  mutation stopService($data: InfrastructureStopServiceInput!) {
    stopService(input: $data) {
      errors { key message }
    }
  }
`;

const withQuery = compose(
  graphql(STOP_SERVICE, {
    props: ({ mutate }) => ({
      stopService: (data) => mutate({
        variables: { data: data }
      })
    })
  })
);

export default connect(null, {cancelStopService})(withQuery(StopServiceFormContainer));